<svg width="40" height="40" fill="none" version="1.1" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
 <g>
  <path d="m14.999 26.666h3.3333v-13.333h-3.3333v13.333zm5-23.333c-9.2 0-16.667 7.4667-16.667 16.667s7.4667 16.667 16.667 16.667 16.667-7.4666 16.667-16.667-7.4667-16.667-16.667-16.667zm0 30c-7.35 0-13.333-5.9833-13.333-13.333s5.9833-13.333 13.333-13.333 13.333 5.9834 13.333 13.333-5.9833 13.333-13.333 13.333zm1.6667-6.6667h3.3333v-13.333h-3.3333v13.333z" fill="#fff"/>
 </g>
</svg>
